import { jsxs as V, jsx as A } from "react/jsx-runtime";
import { useLayoutEffect as D, useRef as z } from "react";
import { _ as u } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import j from "../../hooks/useSpacingToken.js";
import { getSpacingValue as E, fullSpacings as $, gapSpacings as T } from "../../utils/style.js";
import '../../index41.css';const q = "_list-view_1vb03_1", H = "_with-overflow_1vb03_5", I = "_with-grow_1vb03_9", J = "_grid-layout_1vb03_13", K = "_grid-content_1vb03_20", M = "_grid-content-with-sidebar_1vb03_24", Q = "_xs-sidebar_1vb03_39", U = "_sm-sidebar_1vb03_43", X = "_md-sidebar_1vb03_47", Y = "_lg-sidebar_1vb03_51", Z = "_sidebar-position-start_1vb03_58", tt = "_with-sidebar_1vb03_71", it = "_inline-layout_1vb03_76", et = "_with-wrap_1vb03_81", nt = "_with-space-between-contents_1vb03_86", rt = "_with-centered-contents_1vb03_90", ot = "_with-start-alignment_1vb03_94", st = "_block-layout_1vb03_99", at = "_with-full-width_1vb03_108", dt = "_with-background_1vb03_112", ct = "_with-dark-background_1vb03_117", t = {
  listView: q,
  withOverflow: H,
  withGrow: I,
  gridLayout: J,
  gridContent: K,
  gridContentWithSidebar: M,
  xsSidebar: Q,
  smSidebar: U,
  mdSidebar: X,
  lgSidebar: Y,
  sidebarPositionStart: Z,
  withSidebar: tt,
  inlineLayout: it,
  withWrap: et,
  withSpaceBetweenContents: nt,
  withCenteredContents: rt,
  withStartAlignment: ot,
  blockLayout: st,
  withFullWidth: at,
  withBackground: dt,
  withDarkBackground: ct
};
function lt(e) {
  const o = z(null);
  return e && typeof e != "function" ? e : o;
}
function mt(e) {
  const {
    className: o,
    layout: i = "inline",
    withWrap: m,
    withSpaceBetweenContents: p,
    withCenteredContents: S,
    withStartAlignment: f,
    spacing: s,
    withPadding: a,
    withBackground: v,
    withDarkBackground: C,
    children: c,
    numPreferredGridColumns: d = 2,
    minGridColumnSize: l = "12rem",
    gridContentClassName: k,
    withSidebar: w,
    sidebarPosition: y = "end",
    sidebarSize: r = "md",
    spacingOffset: P,
    withFullWidth: B,
    elementRef: L,
    withSpacingOpticalCorrection: W = !1,
    withOverflow: x = !1,
    withGrow: O = !1,
    ...F
  } = e, n = lt(L);
  D(() => {
    var h, b, g;
    if (i === "grid") {
      (h = n.current) == null || h.style.setProperty(
        "--num-preferred-grid-columns",
        String(d)
      ), (b = n.current) == null || b.style.setProperty(
        "--min-grid-column-size",
        String(l)
      );
      const G = a ? 2 : 0, R = d - 1, N = G + R;
      (g = n.current) == null || g.style.setProperty(
        "--reserved-space",
        `calc(${E(s)} * ${N})`
      );
    }
  }, [d, l, i, a, s, n]);
  const _ = j({
    spacing: s,
    offset: P,
    modes: a ? $ : T,
    withoutOpticalCorrection: !W
  });
  return /* @__PURE__ */ V(
    "div",
    {
      ...F,
      ref: n,
      className: u(
        t.listView,
        i === "inline" && t.inlineLayout,
        i === "block" && t.blockLayout,
        i === "grid" && t.gridLayout,
        i !== "grid" && _,
        m && t.withWrap,
        f && t.withStartAlignment,
        p && t.withSpaceBetweenContents,
        S && t.withCenteredContents,
        B && t.withFullWidth,
        v && t.withBackground,
        C && t.withDarkBackground,
        w && t.withSidebar,
        x && t.withOverflow,
        O && t.withGrow,
        o
      ),
      role: i !== "grid" ? "list" : void 0,
      children: [
        i === "grid" && /* @__PURE__ */ A(
          "div",
          {
            className: u(
              t.gridContent,
              _,
              k,
              w && t.gridContentWithSidebar,
              y === "start" && t.sidebarPositionStart,
              r === "xs" && t.xsSidebar,
              r === "sm" && t.smSidebar,
              r === "md" && t.mdSidebar,
              r === "lg" && t.lgSidebar
            ),
            role: "grid",
            children: c
          }
        ),
        i !== "grid" && c
      ]
    }
  );
}
export {
  mt as default
};
